
/*
smooth transition for images - hard
only main image will transition - medium
container proper expansion - medium
add property information on top of the image - easy
*/

import React, {useState, useRef, useEffect} from "react";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./featured-properties.scss"; // Import styles
import {SERVER_URL} from "../../../global_vars";
import axios, { AxiosResponse } from "axios";
import { useTransition, animated } from "@react-spring/web";
import {useNavigate} from "react-router-dom";


interface FeaturedProperty {
    id: number;
    name: string;
    property_images: string[];
    developer_names: string[];
}

interface FeaturedPropertyResponse {
  code: number;
  msg: string;
  data: FeaturedProperty[];
}

const FeaturedProperties = () => {

  const swiperRef = useRef<SwiperRef>(null);
  const [featuredProperties, setFeaturedProperties] = useState<FeaturedProperty[]>([]);
  const [currImage, setCurrImage] = useState(0);

  const navigate = useNavigate();

  const navigateToURL = (url: string) => {
    navigate(`/${url}`);
  }


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrImage((prevIndex) => (prevIndex + 1) % 4);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    axios.get(SERVER_URL+"/property/top").then((res: AxiosResponse<FeaturedPropertyResponse>) => {
      if (res.data.code !== 200) {
        console.log("unable to fetch featured properties");
        return;
      }
      console.log(res.data.data);
      setFeaturedProperties(res.data.data);
    }).catch((err) => {
      console.log(err);
    })
  }, []);

  const transitions = useTransition(currImage, {
    key: currImage,
    from: { opacity: 0.1, position: "absolute" },
    enter: { opacity: 1 },
    leave: { opacity: 0.9 },
    config: { duration: 1500 },
    exitBeforeEnter: false,
  });

  return (
    <div className="featured-properties">
      <div className="featured-properties-heading">
        <h1>LUXORA'S CURRENT INVENTORY</h1>
        <p>PRESENTING YOU WITH DUBAI'S FINEST PROPERTIES</p>
      </div>

      <hr style={{
        width: "90%",
        border: "0.5px solid #A3A3A3",
      }} />

      {/* <div className={"featured-properties-body"}> */}
        <Swiper
          ref={swiperRef}
          modules={[Navigation]}
          slidesPerView={1.25} // Shows part of next/prev slide
          centeredSlides={true}
          speed={1500}
          cssMode={true}
          className={"featured-properties-carousel"}
          navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
        >

          {
            featuredProperties.map((property, index) => (
              <SwiperSlide key={index} className="featured-property-slide" onClick={() => navigateToURL(`property/${property.id}/details`)}>
                <div className="featured-property-card">
                  {transitions((style, i) => (
                    <animated.img
                      key={i}
                      src={property.property_images[i]}
                      alt="Property"
                      className="featured-property-card-img"
                      style={{
                        ...style,
                        position: "absolute",
                      }}
                    />
                  ))}

                  <div className="image-gradient-overlay"></div>

                  <div className={"featured-property-details"}>
                    <h2>{property.name.toUpperCase()}</h2>
                    <h4>BY {property.developer_names[0].toUpperCase()}</h4>
                  </div>
                  
                </div>
              </SwiperSlide>

            ))
          }
        </Swiper>

        <div className={"featured-properties-footer"}>
          <div className="swiper-navigation-buttons">
            <button className="custom-swiper-prev">
              <i className="bi bi-chevron-left"></i>
            </button>
            <button className="custom-swiper-next">
              <i className="bi bi-chevron-right"></i>
            </button>
          </div>
          <div className={"view-properties"}>
            <button className={"view-properties-btn"} onClick={() => navigateToURL("property/list")}>VIEW ALL PROPERTIES</button>
          </div>
        </div>
        
    </div>
  );
};

export default FeaturedProperties;
